import { computed, makeObservable } from "mobx";
import { BaseSyncModel } from "@/store/sync/BaseSyncModel";
import { SyncModelKind } from "@/store/sync/types";
import { WithAppStore } from "@/store/types";
import { UploadedFileBatchModelData } from "./types";
import { SyncUpdateValue } from "@/store/sync/types";

export class UploadedFileBatchObservable extends BaseSyncModel<UploadedFileBatchModelData> {
  public modelKind = SyncModelKind.UploadedFileBatch;

  constructor({
    id,
    data,
    store,
  }: { id: string; data: SyncUpdateValue<UploadedFileBatchModelData> } & WithAppStore) {
    super({ id, data, store });

    makeObservable(this, {
      isEnqueued: computed,
      isPending: computed,
      isDoneProcessing: computed,
      isProcessing: computed,
      startedProcessingAt: computed,
      endedProcessingAt: computed,
      enqueuedAt: computed,
      modelKind: false,
    });
  }

  get startedProcessingAt() {
    return this.modelData.processing_started_at;
  }

  get endedProcessingAt() {
    return this.modelData.processing_ended_at;
  }

  get enqueuedAt() {
    return this.modelData.processing_enqueued_at;
  }

  get isPending() {
    return !this.startedProcessingAt && !this.endedProcessingAt;
  }

  get isProcessing() {
    return this.startedProcessingAt !== null;
  }

  get isEnqueued() {
    return this.enqueuedAt !== null;
  }

  get isDoneProcessing() {
    return this.endedProcessingAt !== null;
  }
}
